// Rules for Product Type - ETF, Mutual fund and Collective Trust
import { IProduct } from '../../../../models/product'
import { ProductTypeRulesService } from '../../../product-type-rules/product-type-rules.service'
import { FundRuleName } from '../fund-rule-name'
import { IFundRule } from '../ifund-rule'

export class ProductTypeETFRule implements IFundRule {
  ruleName = FundRuleName.PRODUCT_TYPE_ETF
  isRuleApplicable(fund: IProduct): boolean {
    return ProductTypeRulesService.isETF(fund)
  }
}

export class ProductTypeMutualFundRule implements IFundRule {
  ruleName = FundRuleName.PRODUCT_TYPE_MUTUAL_FUND
  isRuleApplicable(fund: IProduct): boolean {
    return ProductTypeRulesService.isMutualFund(fund)
  }
}

export class ProductTypeCollectiveTrustRule implements IFundRule {
  ruleName = FundRuleName.PRODUCT_TYPE_COLLECTIVE_TRUST
  isRuleApplicable(fund: IProduct): boolean {
    return ProductTypeRulesService.isCollectiveTrust(fund)
  }
}
